import Vue from 'vue';
import Pagination from '@global/components/global/Pagination';
import sortControl from '@global/components/productList_vue/sort';
import Slick from '@global/vendors/vue-slick';

// import itemFilter from 'components/productList/itemFilter'
if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}

const RenderProductListContent = function () {
  // 篩選
  const sortApp = {
    template: `<sort-control :condition="data" :isload="isload"></sort-control>`,
    components: {
      sortControl,
    },
    props: ['data', 'isload'],
    created: function () {},
    methods: {},
  };
  // 視圖切換
  const gridMode = {
    template: `<ul class="list-options__views">
                <li class="btn-2col" :class="{'active':largeMode}"><a @click.prevent="switchMode(true)" href="#" data-column="2col">2欄</a></li>
                <li class="btn-multi" :class="{'active':!largeMode}"><a @click.prevent="switchMode(false)" href="#" data-column="multi">多欄</a></li>
            </ul>`,
    props: ['largemode'],
    data: function () {
      return {
        largeMode: this.largemode,
      };
    },
    methods: {
      switchMode: function (mode) {
        this.largeMode = mode;
        this.$emit('changegrid', mode);
      },
    },
  };
  new Vue({
    el: '#app-shop',
    components: {
      sortApp,
    },
    data: {
      largeMode: false,
      sortConditionDatas: null,
      sortConditionIsLoad: false,
      bannerSliderConfig: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 6000,
      },
    },
    mounted: function () {
      if ($('.banner-slide').length) {
        $('.banner-slide').slick(this.bannerSliderConfig);
      }
    },
    created: function () {
      this.getSortCondition();
    },
    methods: {
      swichGridMode: function (lMode) {
        this.largeMode = lMode;
      },
      getSortCondition: function () {
        var _this = this;
        $.ajax({
          type: 'GET',
          url: API_URL.SORT_POPUP,
          dataType: 'json',
          xhrFields: {
            withCredentials: true,
          },
          error: function () {
            console.log('error');
          },
          success: function (res) {
            if (res.Code === 200) {
              _this.sortConditionDatas = res.Response;
              _this.sortConditionIsLoad = true;
            }
          },
        });
      },
    },
  });

  // 頁碼
  new Vue({
    el: '#pagination',
    data: {},
    components: {
      Pagination,
    },
    template: `<div>
                <Pagination></Pagination>
              </div>`,
  });
};

export default RenderProductListContent;
